import { render, staticRenderFns } from "./LabelList.vue?vue&type=template&id=1d690402&scoped=true"
import script from "./LabelList.vue?vue&type=script&lang=js"
export * from "./LabelList.vue?vue&type=script&lang=js"
import style0 from "./LabelList.vue?vue&type=style&index=0&id=1d690402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d690402",
  null
  
)

export default component.exports